import { TimeBonusPopup, type CycleScoreApi } from "../gamification";

/** The time-bonus popup for a finished packing cycle, in a full-screen,
 *  click-through layer so it lands near the top of whichever screen the
 *  packer is on — the same spot it takes on the other scanning screens.
 *
 *  This file used to render the floating "session stats" card. The counts
 *  and the points pill now sit in each screen's own bars (see
 *  dispatch-session-chrome.tsx); only the popup still needs a fixed home,
 *  because it fires as the screen changes from Confirm Shipment back to
 *  the scan screens. */
const DispatchTimeBonus = ({ cycle }: { cycle?: CycleScoreApi }) => {
    if (!cycle?.scoring) return null;
    return (
        <div className="dispatch-bonus-layer" aria-hidden="true">
            <TimeBonusPopup
                seconds={cycle.bonus.seconds}
                color={cycle.bonus.color}
                streak={cycle.bonus.streak}
                isBest={cycle.bonus.isBest}
                bumpKey={cycle.bonus.key}
            />
        </div>
    );
};

export default DispatchTimeBonus;
